import React, { Component } from "react";
import PropTypes from "prop-types";

import EmailConfirmationView from "features/application/email-confirmation/view";

class EmailConfirmation extends Component {
  constructor(props) {
    super(props);

    this.state = { isEmailForgotten: false };

    this.termsDescriptionReference = React.createRef();

    this.forgetEmail = this.forgetEmail.bind(this);
  }

  componentDidMount() {}

  componentWillUnmount() {}

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { responseCodes, errorCodes, termsAndConditions } = this.props;

    ((nextProps.responseCodes &&
      JSON.stringify(nextProps.responseCodes) !==
        JSON.stringify(responseCodes) &&
      nextProps.responseCodes.verificationMessage) ||
      (nextProps.errorCodes &&
        JSON.stringify(nextProps.errorCodes) !== JSON.stringify(errorCodes) &&
        nextProps.errorCodes.verificationMessage)) &&
      this.forgetEmail(false);

    this.termsDescriptionReference.current &&
      nextProps.termsAndConditions &&
      nextProps.termsAndConditions !== termsAndConditions &&
      (this.termsDescriptionReference.current.innerHTML =
        nextProps.termsAndConditions.content);
  }

  forgetEmail(status) {
    this.setState({ isEmailForgotten: status });
  }

  render() {
    const {
      errorCodes,
      userData,
      resendVerificationMessage,
      backToPreviousStep,
      sendApiRequest,
    } = this.props;
    const { isEmailForgotten } = this.state;

    return (
      <EmailConfirmationView
        errorCodes={errorCodes}
        userData={userData}
        isEmailForgotten={isEmailForgotten}
        forgetEmail={this.forgetEmail}
        resendVerificationMessage={resendVerificationMessage}
        termsDescriptionReference={this.termsDescriptionReference}
        backToPreviousStep={backToPreviousStep}
        sendApiRequest={sendApiRequest}
      />
    );
  }
}

EmailConfirmation.propTypes = {
  responseCodes: PropTypes.object,
  errorCodes: PropTypes.object,
  userData: PropTypes.object,
  resendVerificationMessage: PropTypes.func,
  backToPreviousStep: PropTypes.func,
  sendApiRequest: PropTypes.func,
  termsAndConditions: PropTypes.object,
};

export default EmailConfirmation;
